export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14750.b2dac18f.jpg";